import { I18nDictionaryLanguageKeysType } from '@affiliate-cabinet/i18n'
import { FlagNamesType } from '@affstore-ds/flags'

export const LANGUAGES_TO_FLAGS_MAP: Record<I18nDictionaryLanguageKeysType, FlagNamesType> = {
  id: 'id',
  ar: 'ar-ar',
  de: 'de',
  en: 'gb',
  es: 'es',
  it: 'it',
  pt: 'pt',
  ru: 'ru',
  sv: 'se',
  th: 'th',
  vi: 'vn',
  zh: 'cn',
}
